module.exports = __webpack_public_path__ + "static/img/cover.0cea9b20.png";